import React from 'react'

const ProjectTitle = ({title, goBack, brandName}) => {
    return <div className="project_title_header">
            <img src={require("../../assets/images/Icons_arrow.svg")} onClick={() => goBack()} />
            <h3> {title ? title : 'NA'} {brandName ? `(${brandName})`: null}</h3>
            </div>
}

export default ProjectTitle